import { esc } from '../ui/icons.js';
import { competenciaExtenso } from '../lib/supabase.js';
import { dados } from '../state.js';
import { ehGestao } from '../auth.js';
import * as Fechamento from '../data/fechamento.js';
import { abrirFicha } from './ficha.js';

/**
 * Histórico e observações sinalizadas.
 *
 * O histórico agora vem do banco e é imutável — escrito por trigger, sem
 * policy de UPDATE nem DELETE. E traz duas datas separadas: a competência
 * (mês de referência) e o dia em que a alteração foi feita de verdade.
 * Isso importa aqui na Tarter, onde é comum fechar jan–ago tudo no mesmo dia.
 */

let registros = [];

export function configurar() {
  const selEmpresa = document.getElementById('histEmpresa');
  const selColab = document.getElementById('histColaborador');

  selEmpresa.innerHTML = '<option value="">Todas as empresas</option>' +
    dados.empresas.map((e) => `<option value="${e.id}">${esc(e.nome)}</option>`).join('');
  // Quem não é gestão só enxerga o próprio histórico — o banco garante
  // isso. Um filtro "Todos os colaboradores" aqui prometeria uma visão
  // que ele não tem, e ainda insinuaria que dá para espiar o colega.
  if (ehGestao()) {
    selColab.innerHTML = '<option value="">Todos os colaboradores</option>' +
      dados.colaboradores.map((c) => `<option value="${c.id}">${esc(c.nome)}</option>`).join('');
    selColab.hidden = false;
  } else {
    selColab.innerHTML = '<option value=""></option>';
    selColab.hidden = true;
  }

  ['histEmpresa', 'histColaborador', 'histTipo', 'histDe', 'histAte']
    .forEach((id) => document.getElementById(id).addEventListener('input', aplicarFiltros));
}

/** Busca no banco (a tela pode ficar aberta enquanto outros trabalham). */
export async function render() {
  const empresaId = document.getElementById('histEmpresa').value || null;
  const tipo = document.getElementById('histTipo').value || null;
  registros = await Fechamento.historico({ empresaId, tipo });
  aplicarFiltros();
}

function aplicarFiltros() {
  const colaboradorId = document.getElementById('histColaborador').value;
  const de = document.getElementById('histDe').value;
  const ate = document.getElementById('histAte').value;

  const lista = registros.filter((h) => {
    const dia = h.criado_em.slice(0, 10);
    return (!colaboradorId || h.colaborador?.id === colaboradorId) &&
           (!de || dia >= de) && (!ate || dia <= ate);
  });

  document.getElementById('histCount').textContent =
    `${lista.length} de ${registros.length} registros`;

  document.querySelector('#histTable tbody').innerHTML = lista.length
    ? lista.map((h) => {
        const data = new Date(h.criado_em);
        const cor = ['ok', 'feito', 'recebido'].includes(h.status_novo) ? 'green'
          : ['parcial', 'analise'].includes(h.status_novo) ? 'amber' : 'red';
        return `<tr>
          <td>${data.toLocaleDateString('pt-BR')}</td>
          <td>${data.toTimeString().slice(0, 5)}</td>
          <td>${esc(h.empresa?.nome || '—')}<div style="font-size:11px;color:var(--text-muted);">${competenciaExtenso(h.competencia)}</div></td>
          <td>${esc(h.colaborador?.nome || '—')}</td>
          <td>${esc(h.descricao)}${h.tipo === 'checklist' ? ' <span style="color:var(--text-muted);font-size:11px;">(checklist)</span>' : ''}${h.tipo === 'documento' ? ' <span style="color:var(--text-muted);font-size:11px;">(documento)</span>' : ''}</td>
          <td><span class="tag ${cor}">${esc(h.status_anterior ?? '—')} → ${esc(h.status_novo)}</span></td>
        </tr>`;
      }).join('')
    : `<tr><td colspan="6" style="color:var(--text-muted);">Nenhum registro com esses filtros. Marque um item de conferência ou uma etapa do checklist para começar o histórico.</td></tr>`;
}

/* ------------------------------------------------------------------ */
/* Observações sinalizadas (derivadas dos itens não-OK)                */
/* ------------------------------------------------------------------ */

const ROTULO = { ok: 'OK', parcial: 'Parcial', pendente: 'Pendente' };
const TAG = { ok: 'green', parcial: 'amber', pendente: 'red' };

export function renderObservacoes() {
  const lista = dados.sinalizados;
  const alvo = document.getElementById('relatoList');
  if (!alvo) return;

  document.getElementById('relatoCount').textContent = `${lista.length} sinalizados`;
  alvo.innerHTML = lista.length
    ? lista.map((f) => {
        const empresa = f.fechamento?.empresa;
        const resp = (empresa?.responsaveis || [])
          .map((r) => r.colaborador?.nome).filter(Boolean).join(', ') || '—';
        return `<div class="relato-card flag row-click" data-emp="${empresa?.id}">
          <div class="relato-top">
            <span class="who">${esc(empresa?.nome || '—')}</span>
            <span class="tag ${TAG[f.status]}">${ROTULO[f.status]}</span>
          </div>
          <div class="meta" style="margin-bottom:8px;">${esc(resp)} · ${esc(f.nome)} · ${competenciaExtenso(f.fechamento?.competencia)}</div>
          <div class="relato-text">${esc(f.obs || 'Sem observação registrada.')}</div>
        </div>`;
      }).join('')
    : `<p style="font-size:13px;color:var(--text-muted);">Nada sinalizado no momento — tudo OK.</p>`;

  alvo.querySelectorAll('.relato-card')
    .forEach((c) => c.addEventListener('click', () => abrirFicha(c.dataset.emp)));
}
